var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['user-layout-wrapper', _vm.isMobile && 'mobile'],attrs:{"id":"userLayout"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"user-layout-lang"},[_c('select-lang',{staticClass:"select-lang-trigger"})],1),_c('div',{staticClass:"user-layout-content"},[_c('router-view')],1)]),_c('div',{attrs:{"id":"particlesId"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }